import moment from "moment";

import Rule from "../Rule";

export default class RulePatientAgeCannotExceed150Years extends Rule {
  static message = "Living patients cannot be more than 150 years old.";

  /**
   * Prevents living patients from having a date of birth more than 150 years
   * before today.
   * @returns {{passed: boolean, message?: string}} Rule evaluation result.
   */
  run() {
    const futurePatientId = Object.keys(this.futureChartData.patient)[0];
    const futurePatient = this.futureChartData.patient[futurePatientId];
    const oldestAllowedDateOfBirth = moment().subtract(150, "years");

    if (futurePatient.deceased) {
      return this.pass();
    }

    if (
      moment(futurePatient.dateOfBirth).isBefore(
        oldestAllowedDateOfBirth,
        "day",
      )
    ) {
      return this.fail();
    }

    return this.pass();
  }
}
